import styled from "styled-components";

export const Posts = styled.section``;
